<template>
    <div id="ContractTypeSectionMapperList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Contract Type Section Mapper List</div>
                        <router-link v-if="canAddConMapper" class="btn btn-primary pull-right" v-bind:to="{name: 'ContractTypeSectionMapperCreate'}" > <i class="fp-add"> </i> Add</router-link>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content contracttype-section-mapper">
                        <section class="data-table bg-white">
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'contractTypeSectionMapper'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listSectionMapperTable"
                                    mode="remote"
                                    title="Contract Type Section Mapper"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: contract_type_section_mapper_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Contract Type Section Mapper" v-if="canUpdateConMapper" class="fp-edit" v-bind:to="{name: 'ContractTypeSectionMapperEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="contract_type_section_mapper_value" id="deleteSectionMapperBtn" v-on:click.prevent="SectionMapperDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

import CustomPagination from '@/components/layout/CustomPagination';
import EventBus from "././event-bus";


Vue.component("custom-pagination", CustomPagination);


    export default {
        name: "ContractTypeSectionMapperList",
        mixins:[commonMixins,dataTableMixins],
        metaInfo() {
            return {title: "Contract Type Section Mapper List | " +process.env.COPYRIGHT_NAME}
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                /* {
                    label: 'Contract',
                    field: 'contract',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Contract", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                }, */
                {
                    label: 'Contract Type',
                    field: 'contract_type_id',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Contract Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                /* {
                    label: 'Asset',
                    field: 'vehicle',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Asset", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                }, */
                {
                    label: 'Asset Type',
                    field: 'vehicle_type_id',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Asset Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Section Rate',
                    field: 'section_id',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Section Rate", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Section Value',
                    field: 'section_value',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Section Value", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'CPI Percent',
                    field: 'cpi_increase_percent',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "CPI Percent", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Rate Percent',
                    field: 'rate_increase_percent',
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Rate Percent", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    sortable: false,
                },
            ],
            rows: [],
            totalRecords: 0,
            contract_type_section_mapper_value: false,
            loading:false,
            canAddConMapper:false,
            canUpdateConMapper:false,
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_contract_type_section_mapper') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_contract_type_section_mapper') {
                            self.contract_type_section_mapper_value = true;
                        }
                        if (permissions[i].name == 'add_contract_type_section_mapper') {
                            self.canAddConMapper = true;
                            self.canUpdateConMapper = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },

            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('code');
                    field:('description');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.code || filters.description ) {
                    this.loadList();
                }
            },*/

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/contracttypesectionmapper/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'contract-type-section-mapper-list')
                    }
                });
            },

            SectionMapperDelete() {
                var data = this.$refs['listSectionMapperTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listSectionMapperTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Section Mapper? ')) {
                    self.loading = true;
                    $("#deleteSectionMapperBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/contracttypesectionmapper/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteSectionMapperBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'contract-type-section-mapper-delete')
                        }
                    });
                }
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/ContractTypeSectionMapperList.vue